import { useEffect, useState } from "react";
import { api, apiError } from "../lib/api";
import { toast } from "sonner";
import { ScrollText, Plus, RefreshCw, MessageCircle, XCircle, Mail, Pencil, ArrowRight } from "lucide-react";

const EVENT_META = {
  created: { label: "Sipariş Oluşturuldu", icon: Plus, cls: "text-blue-600 bg-blue-500/10" },
  status_changed: { label: "Durum Değişti", icon: RefreshCw, cls: "text-amber-600 bg-amber-500/10" },
  whatsapp_sent: { label: "WhatsApp Gönderildi", icon: MessageCircle, cls: "text-emerald-600 bg-emerald-500/10" },
  whatsapp_failed: { label: "WhatsApp Başarısız", icon: XCircle, cls: "text-rose-600 bg-rose-500/10" },
  customer_email_sent: { label: "Müşteri E-postası Gönderildi", icon: Mail, cls: "text-emerald-600 bg-emerald-500/10" },
  customer_email_failed: { label: "Müşteri E-postası Başarısız", icon: XCircle, cls: "text-rose-600 bg-rose-500/10" },
  staff_alert_sent: { label: "Personel Uyarısı Gönderildi", icon: Mail, cls: "text-cyan-600 bg-cyan-500/10" },
  email_skipped: { label: "E-posta Atlandı (adres yok)", icon: XCircle, cls: "text-amber-600 bg-amber-500/10" },
  email_alert_sent: { label: "E-posta Uyarısı", icon: Mail, cls: "text-cyan-600 bg-cyan-500/10" },
  edited: { label: "Düzenlendi", icon: Pencil, cls: "text-slate-600 bg-slate-500/10" },
};

export default function AuditLog() {
  const [events, setEvents] = useState([]);
  const [orders, setOrders] = useState({});

  const load = async () => {
    try {
      const [e, o] = await Promise.all([api.get("/events"), api.get("/orders")]);
      setEvents(e.data);
      const map = {};
      o.data.forEach((x) => (map[x.id] = x.order_no));
      setOrders(map);
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div>
      <div className="mb-5 flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10 text-primary"><ScrollText className="h-5 w-5" /></div>
        <div>
          <h1 className="font-display text-3xl font-black tracking-tight">İşlem Günlüğü</h1>
          <p className="text-sm text-muted-foreground">Tüm sipariş hareketleri ve bildirim olayları · {events.length} kayıt</p>
        </div>
        <button data-testid="audit-refresh" onClick={load} className="ml-auto flex items-center gap-2 rounded-xl border border-border bg-white px-3 py-2 text-sm hover:bg-secondary">
          <RefreshCw className="h-4 w-4" /> Yenile
        </button>
      </div>

      <div className="space-y-2" data-testid="audit-list">
        {events.length === 0 && <div className="rounded-xl border border-dashed border-border py-16 text-center text-muted-foreground">Henüz kayıt yok.</div>}
        {events.map((ev) => {
          const meta = EVENT_META[ev.event_type] || { label: ev.event_type, icon: ScrollText, cls: "text-slate-600 bg-slate-500/10" };
          const Icon = meta.icon;
          return (
            <div key={ev.id} data-testid={`audit-event-${ev.event_type}`} className="flex items-start gap-3 rounded-xl border border-border bg-white p-3.5 shadow-sm">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${meta.cls}`}><Icon className="h-4 w-4" /></div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-semibold">{meta.label}</span>
                  {orders[ev.order_id] && <span className="font-mono text-xs font-bold text-primary">{orders[ev.order_id]}</span>}
                </div>
                <div className="mt-0.5 text-xs text-muted-foreground">
                  {ev.actor_name || "Sistem"} · {new Date(ev.created_at).toLocaleString("tr-TR")}
                </div>
                {ev.payload && Object.keys(ev.payload).length > 0 && (
                  <div className="mt-1.5 flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
                    {ev.payload.from && ev.payload.to && (
                      <span className="inline-flex items-center gap-1 rounded bg-secondary px-2 py-0.5 font-mono">{ev.payload.from} <ArrowRight className="h-3 w-3" /> {ev.payload.to}</span>
                    )}
                    {ev.payload.error && <span className="rounded bg-rose-500/10 px-2 py-0.5 text-rose-600">{ev.payload.error}</span>}
                    {ev.payload.to && !ev.payload.from && <span className="rounded bg-secondary px-2 py-0.5 font-mono">{ev.payload.to}</span>}
                    {ev.payload.changes && <span className="rounded bg-secondary px-2 py-0.5 font-mono">{Object.keys(ev.payload.changes).join(", ")}</span>}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
